import { NoteType } from './NoteType';

export class Note {
    public recID: number | null = 0;
    public noteTypeLkupCode: string | null = null;
    public noteType: NoteType | null = null;
    public noteText: string | null = null;
    public originalNoteText: string | null = null;
    public attachmentRecID: number | null = null;
    public citationRecID: string | null = null;
    public userID: string | null = null;
    public dateEntered: Date | null = null;
}

export function PrepareNotes(notes: Note[]): Note[] {
    for (const item of notes) {
        item.originalNoteText = item.noteText;
    }
    return notes;
}
